<template>
  <svg
    data-v-73b60f0e=""
    data-v-2673c0e4=""
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 20 20"
    aria-label="alert"
    role="img"
    class="c-icon"
  >
    <g data-v-73b60f0e="" fill="#CC0621">
      <path
        d="m17.56 14-5.67-9.86c-1-1.8-2.74-1.8-3.78 0l-5.67 9.86c-1 1.8-.18 3.25 1.9 3.25h11.32c2.08-.04 2.93-1.49 1.9-3.25zm-8.36-6.39a.81.81 0 0 1 .65-.8.84.84 0 0 1 .47.05.85.85 0 0 1 .35.3.81.81 0 0 1 .13.45v3.79a.85.85 0 0 1 -.06.31 1 1 0 0 1 -.19.27 1 1 0 0 1 -.26.18.85.85 0 0 1 -.31.06.87.87 0 0 1 -.32-.06 1.27 1.27 0 0 1 -.27-.16 1 1 0 0 1 -.17-.27.7.7 0 0 1 -.07-.31zm1.46 7.2a.91.91 0 0 1 -.66.28 1 1 0 0 1 -.53-.16.94.94 0 0 1 -.34-.42 1 1 0 0 1 -.08-.41 1.08 1.08 0 0 1 .11-.4.94.94 0 0 1 .27-.32 1.13 1.13 0 0 1 .39-.17.84.84 0 0 1 .54.06 1 1 0 0 1 .43.34.91.91 0 0 1 .15.53.75.75 0 0 1 -.07.36.81.81 0 0 1 -.21.31z"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "box",
      required: true
    },
    width: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: [Number, String],
      default: 16
    },
    color: {
      type: String
    },
    opt: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    icon() {
      if (!this.$icon || !this.$icon[this.name]) return {};
      return this.$icon[this.name];
    },
    option() {
      if (!this.opt) return {};
      return this.opt;
    },
    fill() {
      if (!this.icon || !this.icon.fill) return undefined;
      if (this.icon.fill == "#FFF") return this.icon.fill;
      if (!this.color) return this.icon.fill;
      return this.color;
    },
    stroke() {
      if (!this.icon || !this.icon.stroke) return undefined;
      if (this.icon.stroke == "#FFF") return this.icon.stroke;
      if (!this.color) return this.icon.stroke;
      return this.color;
    },
    viewBox() {
      if (!this.icon.viewBox) return "0 0 24 24";
      return this.icon.viewBox;
    }
  }
};
</script>

<style scoped></style>
